import { useEffect } from "react";

import "./portifolio.css";

import AOS from "aos";
import "aos/dist/aos.css";

import Task from "../../assets/image/task.png";
import Weather from "../../assets/image/weather.png";
import html from "../../assets/icons/html.png";
import css from "../../assets/icons/css.png";
import js from "../../assets/icons/javascript.png";
import react from "../../assets/icons/react.png";

export default function Portifolio() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="portifolio" id="portifolio">
      <p className="tittle port--title" data-aos="fade-up">
        Portifólio <strong>( )</strong>
      </p>
      <div className="portifolio--cards">
        <div className="card" data-aos="fade-left">
          <div className="card--image">
            <img className="port--image" src={Weather} alt="" />
          </div>

          <div className="card--infos">
            <p className="card--tittle">Weather App</p>
            <p className="card--content">
              Projeto em que é possível receber informações atuais de clima de acordo com nome da
              cidade buscado. No projeto é feita uma requisição HTTP em uma API pública na qual
              retorna dados do cliema que podem ser exibidos na tela.
              <p><strong>Visualização Desktop e Mobile</strong></p>
              
            </p>
            <div className="techs--icons">
              <p className="card--tittle card--techs">Techs:</p>
              <img
                className="techs--img"
                src={html}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="100"
              />
              <img
                className="techs--img"
                src={css}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="200"
              />
              <img
                className="techs--img"
                src={react}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="300"
              />
              <img
                className="techs--img"
                src={js}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="400"
              />
            </div>

            <a className="card--link" href="https://sun-or-not.netlify.app/" target="_blank">
              <button className="primary-button card--btn">Acessar projeto</button>
            </a>
          </div>
        </div>
        <div className="card" data-aos="fade-right">
          <div className="card--image">
            <img className="port--image" src={Task} alt="" />
          </div>
          <div className="card--infos">
            <p className="card--tittle">Gerenciador de chamados</p>
            <p className="card--content">
              Esse é um projeto onde é possível gerenciar de chamados. Conta com um sistema de
              cadastro e login com email e senha, utilizando Firebase. Entre as funcionalidades,
              estão a possibilidade cadastrar clientes (com validação de CNPJ), cadastrar chamados
              vinculados a um determinado cliente e também a possibilidade de edição e exclusão de
              chamados.
              <p><strong>Visualização somente Desktop</strong></p>
            </p>
            <div className="techs--icons">
              <p className="card--tittle card--techs">Techs:</p>
              <img
                className="techs--img"
                src={html}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="100"
              />
              <img
                className="techs--img"
                src={css}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="200"
              />
              <img
                className="techs--img"
                src={react}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="300"
              />
              <img
                className="techs--img"
                src={js}
                data-aos="flip-up"
                data-aos-duration="400"
                data-aos-delay="400"
              />
            </div>
            <a className="card--link" href="https://tasks-bay.vercel.app/" target="_blank">
              <button className="primary-button card--btn">Acessar projeto</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
